import { useQuery } from '@tanstack/react-query';
import { useRecoilValue } from 'recoil';
import { projectConfigState } from 'recoil/Academy/projectConfigState';
import { TExams } from 'src/app.type/exams';
import { TExamsDetails } from 'src/app.type/examsDetails';
import ExamApi from 'src/lib/api/exam';
import UserApi from 'src/lib/api/users';
import styled from 'styled-components';
import { convertExamDetailQueryString } from '../module/convertExamDetailQueryString';
import { useRouter } from 'next/router';
import { useCurrentUser } from 'src/app.hooks/useCurrentUser';

interface Props {
  examIdx: number;
}

const CbtBuyButton = ({ examIdx }: Props) => {
  const parsedExamIdx = Number(examIdx);

  const { handlePurchase, handleLoginRedirect } = useRecoilValue(projectConfigState);
  const router = useRouter();
  const { user } = useCurrentUser();

  const { data: userPurchaseCbt = [] } = useQuery<TExams[]>({
    queryKey: ['/apiV2/user/me/exams'],
    queryFn: () => UserApi.getUserPurchases(),
    enabled: Boolean(user),
  });

  const { data: examDetails = null } = useQuery<TExamsDetails[]>({
    queryKey: [`/apiV2/exams/${examIdx}/exam-details`, convertExamDetailQueryString(router.query)],
    queryFn: () => ExamApi.getExamDetails(examIdx, convertExamDetailQueryString(router.query)),
  });

  //TODO: 추후에는 백엔드 값으로 구매된 상품 여부를 판단해야 합니다.
  const isAlreadyPurchasedCbt = userPurchaseCbt.some((cbt) => cbt.examIdx === parsedExamIdx);
  const isPaidExam = examDetails?.some(({ publicLevel }) => publicLevel > 0);

  const shouldDisplayPurchasedButton = !!handlePurchase && isPaidExam;
  if (!shouldDisplayPurchasedButton) return null;

  const handleBuyBtnClick = async () => {
    if (!user) {
      router.push(handleLoginRedirect(window.location.href));
      return;
    }

    await handlePurchase(parsedExamIdx);
  };

  return (
    <StyledButton className="primary" disabled={isAlreadyPurchasedCbt} onClick={handleBuyBtnClick}>
      {isAlreadyPurchasedCbt ? '구매완료' : '시험구매'}
    </StyledButton>
  );
};

export default CbtBuyButton;

const StyledButton = styled.button`
  &:disabled {
    background-color: #dddddd;
    color: #333;

    font-size: 16px;
    font-weight: bold;

    border: none;

    cursor: default;
  }

  &.primary:not(:disabled) {
    background-color: #2f3982;
    color: #fff;
    font-size: 16px;
    font-weight: 700;
  }
`;
